export default "__VITE_ASSET__DJ_ppakl__"